// @ts-nocheck

import { getPrivateIconUrl } from '../config/urls';
import { type BetState } from '../states/entities/bets';
import { type CategoryState } from '../states/entities/categories';
import { type MatchState } from '../states/entities/matches';
import { type StateType } from '../states/index';
import { type Selector } from '../types/selectors';

import { type GetOutcomeFromPropsType } from './_propsGetters_';
import { selectEntitiesBets } from './entities/bets/entitiesBetsPrimary.selector';
import { selectEntitiesCategories } from './entities/categories/entitiesCategoriesPrimary.selector';
import { selectEntitiesMatches } from './entities/matches/entitiesMatchesPrimary.selector';
import {
  selectEntitiesOutcomesEntityBetId,
  selectEntitiesOutcomesEntityIcon,
} from './entities/outcomes/entitiesOutcomesPrimary.selector';

export const selectPrivateOutcomeIconPath: Selector<string | null> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => {
  const outcomeIcon = selectEntitiesOutcomesEntityIcon(state, props);

  return outcomeIcon ? getPrivateIconUrl(outcomeIcon) : null;
};

export const selectOutcomeBetEntity: Selector<BetState | undefined> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => {
  const outcomeBetId = selectEntitiesOutcomesEntityBetId(state, props);
  const bets = selectEntitiesBets(state);

  if (outcomeBetId) {
    return bets[outcomeBetId];
  }
};

export const selectOutcomeBetEntityMatchId: Selector<number | undefined> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => selectOutcomeBetEntity(state, props)?.matchId;

export const selectOutcomeBetEntityBetTitle: Selector<string | undefined> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => selectOutcomeBetEntity(state, props)?.betTitle;

export const selectOutcomeBetMatchEntity: Selector<MatchState | undefined> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => {
  const matchId = selectOutcomeBetEntityMatchId(state, props);
  const matches = selectEntitiesMatches(state);

  if (matchId) {
    return matches[matchId];
  }
};

export const selectOutcomeBetMatchEntityCategoryId: Selector<number | undefined> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => {
  return selectOutcomeBetMatchEntity(state, props)?.categoryId;
};

export const selectOutcomeBetMatchEntityTitle: Selector<string | undefined> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => {
  return selectOutcomeBetMatchEntity(state, props)?.title;
};

export const selectOutcomeBetMatchCategoryEntity: Selector<CategoryState | undefined> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => {
  const categoryId = selectOutcomeBetMatchEntityCategoryId(state, props);
  const categories = selectEntitiesCategories(state);

  if (categoryId) {
    return categories[categoryId];
  }
};

export const selectOutcomeBetMatchCategoryEntitySportId: Selector<number | undefined> = (
  state: StateType,
  props?: GetOutcomeFromPropsType,
) => selectOutcomeBetMatchCategoryEntity(state, props)?.sportId;
